// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"_variables__pc_only___2Vnsq","sp_only":"_variables__sp_only___3j9Je"};